// extracted by mini-css-extract-plugin
export var richtext = "RichText-module--richtext--daa09";